import { render, staticRenderFns } from "./AreaPromoterCRM.vue?vue&type=template&id=1fd9c28e&scoped=true"
import script from "./AreaPromoterCRM.vue?vue&type=script&lang=js"
export * from "./AreaPromoterCRM.vue?vue&type=script&lang=js"
import style0 from "./AreaPromoterCRM.vue?vue&type=style&index=0&id=1fd9c28e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd9c28e",
  null
  
)

export default component.exports